/** @jsx jsx */
import { Fragment } from 'preact';
import { filters } from '@searchspring/snap-toolbox';
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { useTheme, CacheProvider } from '../../../providers';
const CSS = {
    price: ({ theme }) => css({
        color: theme.colors?.primary,
        '&.ss__price--strike': {
            textDecoration: 'line-through',
            color: 'initial',
        },
    }),
};
export function Price(properties) {
    const globalTheme = useTheme();
    const theme = { ...globalTheme, ...properties.theme };
    const props = {
        // default props
        symbol: '$',
        decimalPlaces: 2,
        padDecimalPlaces: true,
        thousandsSeparator: ',',
        decimalSeparator: '.',
        symbolAfter: false,
        lineThrough: false,
        // global theme
        ...globalTheme?.components?.price,
        // props
        ...properties,
        ...properties.theme?.components?.price,
    };
    const { lineThrough, value, symbol, decimalPlaces, padDecimalPlaces, thousandsSeparator, decimalSeparator, symbolAfter, raw, disableStyles, className, style, } = props;
    const formattedPrice = filters.currency(value, {
        symbol,
        decimalPlaces,
        padDecimalPlaces,
        thousandsSeparator,
        decimalSeparator,
        symbolAfter,
    });
    const styling = {};
    if (!disableStyles) {
        styling.css = [CSS.price({ theme }), style];
    }
    else if (style) {
        styling.css = [style];
    }
    return raw ? (jsx(Fragment, null, formattedPrice)) : (jsx(CacheProvider, null,
        jsx("span", { ...styling, className: classnames('ss__price', { 'ss__price--strike': lineThrough }, className) }, formattedPrice)));
}
